export const SET_PASSWORD="app/login/SET_PASSWORD"
export const SET_EMAIL="app/login/SET_EMAIL"
export const SET_AUTH_MESSAGE="app/login/SET_AUTH_MESSAGE"
export const SET_LOGIN_LOADING="app/login/SET_LOGIN_LOADING"
export const USER_LOGOUT="app/login/USER_LOGOUT"
